import { Expose, Type } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { SnNetworkConfiguration } from './network-configuration';

export class SnNetwork extends SnModel {
  @Expose()
  @Type(() => SnNetworkConfiguration)
  public configuration: SnNetworkConfiguration;

  @Expose()
  public name: string;
}
